import { AddressHelper } from '@/helpers/addressHelper';
import { Pipe, PipeTransform } from '@angular/core';
import { Address } from '@eemo/api-client';

@Pipe({
    name: 'fullAddress',
    standalone: true
})
export class FullAddressPipe implements PipeTransform {

  transform(address: Address): unknown {
    return AddressHelper.getFullAddress(address);
  }

}
